export var TermType;
(function (TermType) {
    TermType["REGISTER"] = "REGISTER";
    TermType["APPLICATION"] = "APPLICATION";
})(TermType || (TermType = {}));
export const TermTypeTranslation = {
    [TermType.REGISTER]: 'Rejestracja',
    [TermType.APPLICATION]: 'Wniosek o kartę'
};
//# sourceMappingURL=termType.enum.js.map